import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../Utils/axiosInstance";

const baseUrl = process.env.REACT_APP_BASE_URL;

export const getPostalDetails = createAsyncThunk(
  "postalDetails/getPostalDetails",
  async ({ token, countryCode, postalCode }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/checkout/sessions/${token}/postal-codes`,
        {
          params: {
            postalCode,
            countryCode,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch postal details"
      );
    }
  }
);

const initialState = {
  postalDetails: {},
  postalDetailLoading: false,
  postalErrorMessage: "",
};

const postalDetailsSlice = createSlice({
  name: "postalDetails",
  initialState,
  reducers: {
    removePostalData: (state) => {
      state.postalDetails = {};
      state.postalErrorMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPostalDetails.pending, (state) => {
        state.postalDetailLoading = true;
        state.postalErrorMessage = "";
      })
      .addCase(getPostalDetails.fulfilled, (state, action) => {
        state.postalDetailLoading = false;
        state.postalDetails = action.payload;
      })
      .addCase(getPostalDetails.rejected, (state, action) => {
        state.postalDetailLoading = false;
        state.postalDetails = {};
        state.postalErrorMessage = action.payload || "Unexpected error";
      });
  },
});

export const { removePostalData } = postalDetailsSlice.actions;

export default postalDetailsSlice.reducer;


